/**
 * Mobile Show-More Functionality
 * 
 * This script handles the mobile-only show-more functionality for media-collage-with-text sections.
 * It only initializes when the mobile-show-more class is present on the page.
 */

(function () {
  // Use a global flag to prevent multiple initializations
  if (window.mobileShowMoreInitialized) {
    return;
  }

  function initShowMore() {
    const showMoreButtons = document.querySelectorAll('.mobile-show-more-btn');

    if (showMoreButtons.length === 0) {
      return; // No show-more buttons found, exit early
    }

    showMoreButtons.forEach(function (button) {
      // Check if this button already has an event listener
      if (button.hasAttribute('data-show-more-initialized')) {
        return; // Skip if already initialized
      }

      // Mark as initialized
      button.setAttribute('data-show-more-initialized', 'true');

      // Add event listener
      button.addEventListener('click', handleShowMoreClick);
    });
  }

  function handleShowMoreClick(event) {
    event.preventDefault();
    event.stopPropagation(); // Prevent event bubbling

    const button = this;
    const mobileShowMore = button.closest('.mobile-show-more');
    const content = mobileShowMore.querySelector('.show-more-content');
    const showMoreText = button.querySelector('.show-more-text');
    const showLessText = button.querySelector('.show-less-text');

    if (content.classList.contains('collapsed')) {
      // Expand content
      content.classList.remove('collapsed');
      content.classList.add('expanded');
      showMoreText.style.display = 'none';
      showLessText.style.display = 'inline';
    } else {
      // Collapse content
      content.classList.remove('expanded');
      content.classList.add('collapsed');
      showMoreText.style.display = 'inline';
      showLessText.style.display = 'none';
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShowMore);
  } else {
    initShowMore();
  }

  // Mark as initialized globally
  window.mobileShowMoreInitialized = true;
})(); 